export default {
  labels: {
    google_place: 'Google-Platz',
    menu_import: 'Menü-Import',
    live: 'Live',
    setting_up: 'Einrichtung läuft',
  },
  buttons: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    continue_setup: 'Einrichtung fortsetzen',
  },
  delete_confirmation: 'Bist du sicher?',
};
